import React from 'react'

import { Table } from '_zari/core'

const tableHeaderRows = [
  { label: 'CENTRO COSTO' },
  { label: 'CUENTA CONTABLE DEBE' },
  { label: 'CUENTA CONTABLE HABER' },
  { label: 'PARTICIPACION' },
  { label: '' }
]

const DetalleTablaSection = ({ detalles, dispatch }) => {
  const clickEliminar = React.useCallback(
    ({ _idFila }) => {
      dispatch({ type: 'eliminar', payload: { _idFila } })
    },
    [dispatch]
  )

  const tableRowTemplate = React.useCallback(
    row => (
      <Table.Row key={row._idFila}>
        <Table.Cell align='center'>{row.centroCostoNivel2Info || '--'}</Table.Cell>
        <Table.Cell align='center'>{row.cuentaContableDebeInfo || '--'}</Table.Cell>
        <Table.Cell align='center'>{row.cuentaContableHaberInfo || '--'}</Table.Cell>
        <Table.Cell align='center'>{row.porcentajeParticipacion || '--'}</Table.Cell>
        <Table.Cell>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar({ _idFila: row._idFila })}>
                Eliminar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </Table.Cell>
      </Table.Row>
    ),
    [clickEliminar]
  )

  return (
    <Table containerId='container-detallesnuevoasiento' filas={detalles} tablaDetalle headRows={tableHeaderRows} rowTemplate={tableRowTemplate} />
  )
}

export default React.memo(DetalleTablaSection)
